module.exports = __webpack_public_path__ + "static/media/LizKipp.1cabb9e5.jpg";